interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-lg'
          : 'bg-[#5D4037]/85 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/712eeffae6bd09692d30f095b0e3dfd2/fcd018db8c20410ecd57316f5b829fce.png" 
              alt="Aserradero Santa Rosa Logo" 
              className="h-12 w-12 object-contain"
            />
            <div className="font-serif font-bold text-xl text-[#F5E6D3]" style={{ color: isScrolled ? '#5D4037' : '#F5E6D3' }}>
              Aserradero Santa Rosa
            </div>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-[#5D4037] hover:text-[#D4AF37]'
                  : 'text-white hover:text-[#D4AF37]'
              }`}
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('productos')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-[#5D4037] hover:text-[#D4AF37]'
                  : 'text-white hover:text-[#D4AF37]'
              }`}
            >
              Productos
            </button>
            <button
              onClick={() => scrollToSection('servicios')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-[#5D4037] hover:text-[#D4AF37]'
                  : 'text-white hover:text-[#D4AF37]'
              }`}
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('nosotros')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-[#5D4037] hover:text-[#D4AF37]'
                  : 'text-white hover:text-[#D4AF37]'
              }`}
            >
              Nosotros
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'text-[#5D4037] hover:text-[#D4AF37]'
                  : 'text-white hover:text-[#D4AF37]'
              }`}
            >
              Contacto
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
